import { fetchAuthSession } from 'aws-amplify/auth';
import { post, put, del } from 'aws-amplify/api';
import { useMutation, useQueryClient } from 'react-query';
import { FACTS_SHEET_QUERY_KEY } from './useFactsSheetQuery';

export const useFactsSheetPostMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: 'factssheetapi',
        path: '/facts-sheet',
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FACTS_SHEET_QUERY_KEY] });
    },
  });
};

export const useFactsSheetPutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: 'factssheetapi',
        path: '/facts-sheet',
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FACTS_SHEET_QUERY_KEY] });
    },
  });
};

export const useFactsSheetDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const session = await fetchAuthSession();
      const { body } = await del({
        apiName: 'factssheetapi',
        path: '/facts-sheet',
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          queryParams: { id: id },
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FACTS_SHEET_QUERY_KEY] });
    },
  });
};
